<template>
  <el-dialog :visible="isVisible" custom-class="cookie-dialog" :before-close="handleClose"
    :close-on-click-modal="true" :close-on-press-escape="true">
    <div class="offText">  
      <!-- <p>{{ $t('officialAlert.text') }}</p> -->
       <p>{{ $t('officialAlert.text')+' ' }}{{ country }}{{ $t('officialAlert.text1') }}</p>
      <!-- <p>IP地址: {{ ip }}</p> -->
      <!-- <p>国家: {{ country }}</p> -->
    </div>
    <div class="offText-btn">
      <div class="offText-btn-item">
        <button @click="handleClose" class="custom-button">{{ $t('officialAlert.btnText')
          }}</button>
      </div>
      <div class="offText-btn-item">
        <button @click="handleClose" class="custom-button">{{ $t('officialAlert.btnText1')
          }}</button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import axios from 'axios';
export default {
  name: 'formPc',
  data() {
    return {
      isVisible: true,
      isMobile: false,
      ip: '',
      country: '',
    }
  },
  mounted() {
    this.isMobile = this.checkMobile();
    this.getVisitorInfo();
  },
  methods: {
    checkMobile() {
      const ua = navigator.userAgent
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    },
    handleClose() {
      // bus.$emit('inquiry-form', false)
      // 存储当前时间戳
      const timestamp = new Date().getTime();
      localStorage.setItem('alertClosedTimestamp', timestamp);
      this.isVisible = false;
    },
    async getVisitorInfo() {
      try {
        // 获取IP地址
        const ipResponse = await axios.get('https://ipapi.co/json/');
        this.ip = ipResponse.data.ip;

        // 根据IP获取国家信息
        const geoResponse = await axios.get(`https://ipapi.co/${this.ip}/json/`);
        this.country = geoResponse.data.country_name;
      } catch (error) {
        console.error('获取IP或国家信息失败:', error);
      }
    },
  }
}
</script>
<style scoped>
:deep(.cookie-dialog-mobile) {
  border-radius: 30px;
  padding: 5vw  2vw;
}
:deep(.cookie-dialog) {
  padding: 30px 30px 30px;
  background: #e8e2d9;
  color: #422b20;
  top: 100px;
  position: fixed;
  width: 500px;
  z-index: 2000;
  transform: translateY(0%);
  max-height: 88vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 0!important;
  left: 50%;
  transform: translateX(-50%);
}

:deep(.el-dialog__header) {
  padding: 0 !important;
}

:deep(.el-dialog__body) {
  padding: 1px 25px 1px !important;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  font-size: 16px;
  color: #1e1e1e !important;
}
 :deep(.cookie-dialog-mobile .el-dialog__headerbtn .el-dialog__close) {
  font-size: 5vw;
  color: #1e1e1e !important;
}

:deep(.el-input.is-active el-input__inner),
:deep(.el-input__inner:focus) {
  border-color: #aaaaaa;
}

/* el-range-editor.is-active，.el-ramge-editor.i8-active:hover,.el-gelect .el-input.is-focug .elinput imerborder-color:#409EFF */
.custom-button-mobile {
  background: #1E1E1E;
  border-radius: 8px;
  font-size: 3vw;
  padding: 3vw 1vw;
  border-color: #1E1E1E;
  color: #fff;
  width: 100%;
}
.custom-button{
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: inline-block;
  padding: 10px calc(15px + 20px);
  width: 100%;
  margin: 0;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  text-align: center;
  vertical-align: middle;
  line-height: 1.6;
  cursor: pointer;
  border: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: var(--alt-btn-border-radius);
  background-color: #422b20;
  color: #e8e2d9;
  font-family: var(--button-font-stack);
  font-weight: var(--button-font-weight);
  font-style: var(--button-font-style);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 2px;
}
.custom-button:not(:disabled):not(.standalone-icon--wrapper):not(.swiper-button-disabled):not(.disabled):not(.custom-button--secondary):hover:after{
  background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
  content: "";
  height: 100%;
  left: 150%;
  position: absolute;
  top: 0;
  transform: skew(-20deg);
  width: 200%;
  animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
}
.offText {
  margin-top: 5%;
}
.offText-mobile {
  margin-top: 5%;
}

.offText p {
  font-family: math;
  font-weight: var(--header-font-weight);
  letter-spacing: var(--heading-spacing);
  text-transform: var(--heading-font-case);
  line-height: var(--heading-line-height);
  color: var(--font-color);
  text-align: center;
  font-size: 18px;
}

.offText-btn {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
@media screen and (max-width: 767px) {
  :deep(.cookie-dialog) {
    width: 100%;
    height: fit-content;
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 15px;
  }
}
</style>